"use strict";
exports.__esModule = true;
let device = require("./device");
exports.device = device;
/* 所有样式表 */
let sheets = new Map();
/* 添加自定义样式表，例：addSheets({ mb: (v: any) => `{ margin-bottom: ${v}; }`})  */
exports.addShit = function (objs) {
    Object.keys(objs).forEach(function (key) {
        sheets.set(key, objs[key]);
        // console.log(key, objs, objs[key])
    });
    // console.log(objs, 'addSheets', sheets)
    return sheets;
};
exports.removeShit = function (keys) {
    keys.forEach(function (key) {
        sheets.delete(key);
    });
    // console.log(objs, 'addSheets', sheets)
    return sheets;
};
/* 添加默认的媒体查询和设备查询 */
exports.addShit({
    "@sm": function (v) { return "@media (min-width: 640px) {" + v + "}"; },
    "@md": function (v) { return "@media (min-width: 768px) {" + v + "}"; },
    "@lg": function (v) { return "@media (min-width: 1024px) {" + v + "}"; },
    "@xl": function (v) { return "@media (min-width: 1280px) {" + v + "}"; },
    "@ios": function (v) {
        return "@media (min-width: " + (device.isIos ? "0px" : "9999px") + ") {" + v + "}";
    },
    "@android": function (v) {
        return "@media (min-width: " + (device.isAndroid ? "0px" : "9999px") + ") {" + v + "}";
    },
    "@native": function (v) {
        return "@media (min-width: " + (device.isNative ? "0px" : "9999px") + ") {" + v + "}";
    },
    "@pc": function (v) {
        return "@media (min-width: " + (device.isPc ? "0px" : "9999px") + ") {" + v + "}";
    }
});
/* 用于缓存 css 片段的插入 */
let appendCssCache = new Set();
/* 用于插入css片段 */
let appendCss = function (css) {
    if (appendCssCache.has(css)) {
        return;
    }
    appendCssCache.add(css);
    let ele = document.createElement("style");
    ele.innerHTML = css;
    // tslint:disable-next-line
    ele.type = "text/css";
    document.head.appendChild(ele);
};

const forceElementState = (type) => {
    const mapping = { 'hover': ':', 'before': '::', 'after': '::' }
    const result = mapping[type] || ':'
    // console.log(result, 'forceElementState', type)
    return result
}
/* 用于缓存 shit 的计算逻辑 */
let shitCache = new Map();
/* shit 的主函数，用于实现 shit 语法，返回用于 className 的字符串 */
exports.shit = function (inlist) {
    if (!inlist) return ''
    // 实现 tagged-template
    let param = typeof inlist === "string" ? inlist : inlist.join("");
    // param = param.replace(/\s+/g, "")
    // 如果计算过，直接返回结果
    if (shitCache.has(param)) {
        return shitCache.get(param);
    }
    // 如果内容包含 {, 表示是一个纯 css，只需要插入内容，不需要计算 className
    if (param.indexOf("{") > 0) {
        appendCss(param);
        // 记录缓存
        shitCache.set(param, param);
        return "";
    }
    // 得到属性列表
    let list = param.split(";");
    let classname = "";
    // 开始计算每一个属性
    list.forEach(function (str) {

        str = str.trim();
        if (str === "") {
            return;
        }
        let obj = str.split(":");
        if (obj.length === 1) {
            if (str[0] === ".") {
                classname += str + " ";
                return;
            }
            let component = sheets.get(str);
            // console.log(component, str, classname)
            if (typeof component === "string") { // sheets查找component的默认名称
                classname += exports.shit(component) + " ";
            }
            return;
        }
        // tslint:disable-next-line
        let name = "f-" + str.replace(/[^-0-0a-zA-Z]/g, function (reg) { return "_" + reg.charCodeAt(0).toString(16) + "_"; });
        // console.log(str, name)
        let media = obj[obj.length - 4] || "";
        let hover = obj[obj.length - 3] || "";
        let sheet = obj[obj.length - 2] || "";
        // console.log(hover, obj)
        // console.log(obj, sheets, str, { media, hover, sheet })
        if (obj.length === 3 && hover[0] === "@") { // 媒体查询
            media = hover;
            hover = "";
        }
        let value = obj[obj.length - 1] || "";
        value = value.trim();
        // 记录 important 逻辑
        let isImportant = false;
        if (value[value.length - 1] === "!") {
            isImportant = true;
            value = value.substr(0, value.length - 1);
        }
        // 实现 --value -> let(--value)
        if (value.indexOf("--") === 0) {
            value = "let(" + value + ")";
        }
        // 实现 ! -> !important
        // if (isImportant) {
        //     value = value + " !important";
        // }
        // 计算并插入css
        let css = "";
        let block = "";
        let mediaSheet = media[0] === "@" ? sheets.get(media) : "";
        let cssSheet = sheets.get(sheet);
        // 如果是 sheet，使用 cssSheet 返回 block，
        // 如果是 string(component)，直接使用 value, 因为 value 在其他逻辑已然计算过了
        block = typeof cssSheet === "function" ? cssSheet(value) : "{" + sheet + ":" + value + ";}";
       
        isImportant && (block = block.replace(/;/g, ' !important;'))
        // console.log(value, cssSheet, block, sheet, obj, param, inlist)
        // 拼装 css 内容
        css = "." + name + (hover ? forceElementState(hover) : "") + hover + " " + block;
        // console.log(hover, css)
        // 实现媒体查询类的 sheet
        if (typeof mediaSheet === "function") {
            css = mediaSheet(css);
        }
        // 插入css，内部做拦截
        appendCss(css);
        // 返回拼接后的 classname
        classname += name + " ";
    });
    // 记录缓存
    shitCache.set(param, classname);
    return classname;
}
